import axios from 'axios';
import { CANCEL_PACKAGE, CANCEL_TOUR, DELETE_TOUR, GET_TOUR, GET_TOURS, POST_TOUR, UPDATE_TOUR } from "../routes";

export default {
    async all(options = {}) {
        return await axios.get(GET_TOURS, options);
    },
    async get(tour, options = {}) {
        return await axios.get(GET_TOUR(tour), options);
    },
    async create(data, options = {}) {
        return await axios.post(POST_TOUR, data, options);
    },
    async update(tour, options = {}) {
        return await axios.patch(UPDATE_TOUR(tour), options);
    },
    async delete(tour, options = {}) {
        return await axios.delete(DELETE_TOUR(tour), options);
    },
    async cancelPackage(tour, options = {}) {
        return await axios.post(CANCEL_PACKAGE(tour), options);
    },
    async cancelTour(tour, options = {}) {
        return await axios.post(CANCEL_TOUR(tour), options);
    }
};
